import React, { useContext } from 'react';
import { ThemeProvider, ThemeContext } from 'styled-components';

import { themes } from '../../ui/design-tokens';
import Wrapper from '../../ui/Wrappers';
import { Module, Container } from './styles';

interface IProps {
  theme?: string;
  title?: string;
  heading?: string;
  text?: string;
  component?: boolean;
  center?: boolean;
  wrapper?: boolean;
}

const Wysiwyg = ({ text, wrapper = true, ...props }: IProps) => {
  const themeContext = useContext(ThemeContext)
  const cleanedTheme = props.theme && props.theme !== undefined ? props.theme : 'white';
  const isGradient = cleanedTheme.endsWith('_gradient');

  const ThemeContainer = ({ children }) =>
    themeContext && !props.theme ? (
      <>{children}</>
    ) : (
      <ThemeProvider theme={themes[isGradient ? 'gradients' : 'basic'][cleanedTheme]}>
        {children}
      </ThemeProvider>
    );

  const ContentWrapper = wrapper ? Wrapper : Container;

  const formattedText =
    props.title && props.heading
      ? `${props.heading === 'heading_2' ? '<h2>' : '<h3>'}${props.title}${
          props.heading === 'heading_2' ? '</h2>' : '</h3>'
        }${text ? text : ''}`
      : text;
  return (
    <ThemeContainer>
      {props.component ? (
        <Module>
          <Wrapper
            as={Container}
            {...props}
            size="reader"
            center={props.center}
            dangerouslySetInnerHTML={{ __html: formattedText }}
          />
        </Module>
      ) : (
        <ContentWrapper
          as={Container}
          {...props}
          size="reader"
          center={props.center}
          dangerouslySetInnerHTML={{ __html: formattedText }}
        />
      )}
    </ThemeContainer>
  );
};

export default Wysiwyg;
